export default "__VITE_ASSET__CypRNXZc__"